import { render, staticRenderFns } from "./Kurzveranstaltung.vue?vue&type=template&id=289c26d0"
import script from "./Kurzveranstaltung.vue?vue&type=script&lang=js"
export * from "./Kurzveranstaltung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports